import { render, staticRenderFns } from "./ImportCoupons.vue?vue&type=template&id=70d81a66&"
import script from "./ImportCoupons.vue?vue&type=script&lang=js&"
export * from "./ImportCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports